// extracted by mini-css-extract-plugin
export default {"wrapper":"InputOTP_wrapper__WKZLu","item":"InputOTP_item__RcHwC"};